import {SHOW_SPINNER, HIDE_SPINNER } from './action';

const initialState = {
    spinner: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_SPINNER: 
      return true;
    case HIDE_SPINNER:
      return false;
    default: {
      return state;
    }
  }
};

export default reducer;
